import React from "react";

import Notice from "@appComponents/Notice/Notice";

import * as style from "./CustodyOfFundsNoticeStyle.module.scss"

type Props = {
  noDivider: boolean;
  style?: React.CSSProperties;
};

const CustodyOfFundsNotice = (props: Props) => (
  <Notice {...props}>
    <p className={style.header}>Custody of funds</p>
    <p className={style.content}>
      All client funds are held solely by the Virtual Assets Broker in the
      British Virgin Islands. The BF Platform Operator in the Cayman Islands
      does not provide any custody services for client funds.
    </p>
  </Notice>
);

export default CustodyOfFundsNotice;
